import { render, staticRenderFns } from "./FrameworkTopBar.vue?vue&type=template&id=5ddfe0fc&"
import script from "./FrameworkTopBar.vue?vue&type=script&lang=js&"
export * from "./FrameworkTopBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports